import { SVGTemplateResult } from 'lit';

import { actionsIcon } from './actions';
import { addCircleIcon } from './add-circle';
import { addIcon } from './add';
import { apiIcon } from './api';
import { archiveFolderIcon } from './archive-folder';
import { archiveIcon } from './archive';
import { arrowDownIcon } from './arrow-down';
import { arrowLeftIcon } from './arrow-left';
import { arrowRightIcon } from './arrow-right';
import { arrowUpIcon } from './arrow-up';
import { attachIcon } from './attach';
import { billingIcon } from './billing';
import { botIcon } from './bot';
import { branchIcon } from './branch';
import { bucketIcon } from './bucket';
import { bulkIcon } from './bulk';
import { businessSecurityIcon } from './business-security';
import { calendarIcon } from './calendar';
import { caretDownOutlineIcon } from './caret-down-outline';
import { caretDownIcon } from './caret-down';
import { caretLeftOutlineIcon } from './caret-left-outline';
import { caretLeftIcon } from './caret-left';
import { caretRightOutlineIcon } from './caret-right-outline';
import { caretRightIcon } from './caret-right';
import { caretUpOutlineIcon } from './caret-up-outline';
import { caretUpIcon } from './caret-up';
import { chartBarIcon } from './chart-bar';
import { chartLineIcon } from './chart-line';
import { chartPieIcon } from './chart-pie';
import { chatAddIcon } from './chat-add';
import { chatDeleteIcon } from './chat-delete';
import { chatMessageIcon } from './chat-message';
import { chatQuestionIcon } from './chat-question';
import { chatSupportIcon } from './chat-support';
import { checkmarkIcon } from './checkmark';
import { chevronDownIcon } from './chevron-down';
import { chevronLeftIcon } from './chevron-left';
import { chevronRightIcon } from './chevron-right';
import { chevronUpIcon } from './chevron-up';
import { clipboardIcon } from './clipboard';
import { clockIcon } from './clock';
import { closeIcon } from './close';
import { cloudDownloadIcon } from './cloud-download';
import { cloudFilledIcon } from './cloud-filled';
import { cloudSecurityIcon } from './cloud-security';
import { cloudSyncIcon } from './cloud-sync';
import { cloudUploadIcon } from './cloud-upload';
import { cloudIcon } from './cloud';
import { collapseAllIcon } from './collapse-all';
import { collapseIcon } from './collapse';
import { commonServicesIcon } from './common-services';
import { communityIcon } from './community';
import { configurationIcon } from './configuration';
import { copyIcon } from './copy';
import { dashboardIcon } from './dashboard';
import { delayIcon } from './delay';
import { deleteIcon } from './delete';
import { deniedIcon } from './denied';
import { desktopIcon } from './desktop';
import { diagnosticsAltIcon } from './diagnostics-alt';
import { diagnosticsIcon } from './diagnostics';
import { dnsIcon } from './dns';
import { doNotCallIcon } from './do-not-call';
import { doNotEmailAltIcon } from './do-not-email-alt';
import { doNotEmailIcon } from './do-not-email';
import { docAddIcon } from './doc-add';
import { docContractIcon } from './doc-contract';
import { docRemoveIcon } from './doc-remove';
import { dosProtectionsIcon } from './dos-protections';
import { doubleChevronDownIcon } from './double-chevron-down';
import { doubleChevronLeftIcon } from './double-chevron-left';
import { doubleChevronRightIcon } from './double-chevron-right';
import { doubleChevronUpIcon } from './double-chevron-up';
import { downloadIcon } from './download';
import { editIcon } from './edit';
import { emailAddIcon } from './email-add';
import { emailReadIcon } from './email-read';
import { emailReplyIcon } from './email-reply';
import { emailUnreadIcon } from './email-unread';
import { exclamationIcon } from './exclamation';
import { expandAllIcon } from './expand-all';
import { expandIcon } from './expand';
import { exportIcon } from './export';
import { externalLinkIcon } from './external-link';
import { feedbackIcon } from './feedback';
import { filterFilledIcon } from './filter-filled';
import { filterIcon } from './filter';
import { flagFilledIcon } from './flag-filled';
import { flagIcon } from './flag';
import { folderAddIcon } from './folder-add';
import { folderClosedFilledIcon } from './folder-closed-filled';
import { folderClosedIcon } from './folder-closed';
import { folderOpenIcon } from './folder-open';
import { folderRemoveIcon } from './folder-remove';
import { globeIcon } from './globe';
import { gripperIcon } from './gripper';
import { hamburgerMenuIcon } from './hamburger-menu';
import { helpCircleFilledIcon } from './help-circle-filled';
import { helpCircleIcon } from './help-circle';
import { helpDocumentationIcon } from './help-documentation';
import { hideIcon } from './hide';
import { hierarchyIcon } from './hierarchy';
import { historyIcon } from './history';
import { homeIcon } from './home';
import { imageIcon } from './image';
import { incognitoIcon } from './incognito';
import { incrementIcon } from './increment';
import { infoFilledIcon } from './info-filled';
import { infoIcon } from './info';
import { iotCloudIcon } from './iot-cloud';
import { ipPinIcon } from './ip-pin';
import { keyIcon } from './key';
import { kpiBarIcon } from './kpi-bar';
import { lightningIcon } from './lightning';
import { linkIcon } from './link';
import { listViewIcon } from './list-view';
import { loadFailureIcon } from './load-failure';
import { lockedIcon } from './locked';
import { mapPinIcon } from './map-pin';
import { marketplaceIcon } from './marketplace';
import { mediaIcon } from './media';
import { messageIcon } from './message';
import { moduleIcon } from './module';
import { moveIcon } from './move';
import { networkOperatorIcon } from './network-operator';
import { networkIcon } from './network';
import { notificationsOffIcon } from './notifications-off';
import { notificationsIcon } from './notifications';
import { originServicesIcon } from './origin-services';
import { pendoTourIcon } from './pendo-tour';
import { phoneIcon } from './phone';
import { pinOutlineIcon } from './pin-outline';
import { pinIcon } from './pin';
import { pointerIcon } from './pointer';
import { printIcon } from './print';
import { progressIcon } from './progress';
import { redoIcon } from './redo';
import { reloadIcon } from './reload';
import { resetIcon } from './reset';
import { scheduleReportsIcon } from './schedule-reports';
import { scheduleIcon } from './schedule';
import { searchIcon } from './search';
import { securityAlertFilledIcon } from './security-alert-filled';
import { securityAlertIcon } from './security-alert';
import { securityShieldIcon } from './security-shield';
import { serverIcon } from './server';
import { settingsIcon } from './settings';
import { shareIcon } from './share';
import { showIcon } from './show';
import { snapshotIcon } from './snapshot';
import { sortAscendingIcon } from './sort-ascending';
import { sortDescendingIcon } from './sort-descending';
import { sortIcon } from './sort';
import { sslOffIcon } from './ssl-off';
import { sslIcon } from './ssl';
import { stackIcon } from './stack';
import { starEmptyIcon } from './star-empty';
import { starFilledIcon } from './star-filled';
import { statusAlertFilledIcon } from './status-alert-filled';
import { statusAlertIcon } from './status-alert';
import { statusDeniedFilledIcon } from './status-denied-filled';
import { statusFailureFilledIcon } from './status-failure-filled';
import { statusFailureIcon } from './status-failure';
import { statusSuccessFilledIcon } from './status-success-filled';
import { statusSuccessIcon } from './status-success';
import { subtractCircleIcon } from './subtract-circle';
import { subtractIcon } from './subtract';
import { supportHeadsetIcon } from './support-headset';
import { swapIcon } from './swap';
import { tableViewIcon } from './table-view';
import { tagFilledIcon } from './tag-filled';
import { tagIcon } from './tag';
import { taskIcon } from './task';
import { thumbUpIcon } from './thumb-up';
import { tipLightbulbIcon } from './tip-lightbulb';
import { tlsOffIcon } from './tls-off';
import { tlsIcon } from './tls';
import { undoIcon } from './undo';
import { unlockedIcon } from './unlocked';
import { uploadIcon } from './upload';
import { userAddIcon } from './user-add';
import { userContentIcon } from './user-content';
import { userRemoveIcon } from './user-remove';
import { userIcon } from './user';
import { usersIcon } from './users';
import { viewDetailsIcon } from './view-details';
import { wafIcon } from './waf';
import { wizardIcon } from './wizard';
import { wrenchIcon } from './wrench';
import { zoomInIcon } from './zoom-in';
import { zoomOutIcon } from './zoom-out';

export const IconMap: Record<string, SVGTemplateResult> = {
  'actions': actionsIcon,
  'add-circle': addCircleIcon,
  'add': addIcon,
  'api': apiIcon,
  'archive-folder': archiveFolderIcon,
  'archive': archiveIcon,
  'arrow-down': arrowDownIcon,
  'arrow-left': arrowLeftIcon,
  'arrow-right': arrowRightIcon,
  'arrow-up': arrowUpIcon,
  'attach': attachIcon,
  'billing': billingIcon,
  'bot': botIcon,
  'branch': branchIcon,
  'bucket': bucketIcon,
  'bulk': bulkIcon,
  'business-security': businessSecurityIcon,
  'calendar': calendarIcon,
  'caret-down-outline': caretDownOutlineIcon,
  'caret-down': caretDownIcon,
  'caret-left-outline': caretLeftOutlineIcon,
  'caret-left': caretLeftIcon,
  'caret-right-outline': caretRightOutlineIcon,
  'caret-right': caretRightIcon,
  'caret-up-outline': caretUpOutlineIcon,
  'caret-up': caretUpIcon,
  'chart-bar': chartBarIcon,
  'chart-line': chartLineIcon,
  'chart-pie': chartPieIcon,
  'chat-add': chatAddIcon,
  'chat-delete': chatDeleteIcon,
  'chat-message': chatMessageIcon,
  'chat-question': chatQuestionIcon,
  'chat-support': chatSupportIcon,
  'checkmark': checkmarkIcon,
  'chevron-down': chevronDownIcon,
  'chevron-left': chevronLeftIcon,
  'chevron-right': chevronRightIcon,
  'chevron-up': chevronUpIcon,
  'clipboard': clipboardIcon,
  'clock': clockIcon,
  'close': closeIcon,
  'cloud-download': cloudDownloadIcon,
  'cloud-filled': cloudFilledIcon,
  'cloud-security': cloudSecurityIcon,
  'cloud-sync': cloudSyncIcon,
  'cloud-upload': cloudUploadIcon,
  'cloud': cloudIcon,
  'collapse-all': collapseAllIcon,
  'collapse': collapseIcon,
  'common-services': commonServicesIcon,
  'community': communityIcon,
  'configuration': configurationIcon,
  'copy': copyIcon,
  'dashboard': dashboardIcon,
  'delay': delayIcon,
  'delete': deleteIcon,
  'denied': deniedIcon,
  'desktop': desktopIcon,
  'diagnostics-alt': diagnosticsAltIcon,
  'diagnostics': diagnosticsIcon,
  'dns': dnsIcon,
  'do-not-call': doNotCallIcon,
  'do-not-email-alt': doNotEmailAltIcon,
  'do-not-email': doNotEmailIcon,
  'doc-add': docAddIcon,
  'doc-contract': docContractIcon,
  'doc-remove': docRemoveIcon,
  'dos-protections': dosProtectionsIcon,
  'double-chevron-down': doubleChevronDownIcon,
  'double-chevron-left': doubleChevronLeftIcon,
  'double-chevron-right': doubleChevronRightIcon,
  'double-chevron-up': doubleChevronUpIcon,
  'download': downloadIcon,
  'edit': editIcon,
  'email-add': emailAddIcon,
  'email-read': emailReadIcon,
  'email-reply': emailReplyIcon,
  'email-unread': emailUnreadIcon,
  'exclamation': exclamationIcon,
  'expand-all': expandAllIcon,
  'expand': expandIcon,
  'export': exportIcon,
  'external-link': externalLinkIcon,
  'feedback': feedbackIcon,
  'filter-filled': filterFilledIcon,
  'filter': filterIcon,
  'flag-filled': flagFilledIcon,
  'flag': flagIcon,
  'folder-add': folderAddIcon,
  'folder-closed-filled': folderClosedFilledIcon,
  'folder-closed': folderClosedIcon,
  'folder-open': folderOpenIcon,
  'folder-remove': folderRemoveIcon,
  'globe': globeIcon,
  'gripper': gripperIcon,
  'hamburger-menu': hamburgerMenuIcon,
  'help-circle-filled': helpCircleFilledIcon,
  'help-circle': helpCircleIcon,
  'help-documentation': helpDocumentationIcon,
  'hide': hideIcon,
  'hierarchy': hierarchyIcon,
  'history': historyIcon,
  'home': homeIcon,
  'image': imageIcon,
  'incognito': incognitoIcon,
  'increment': incrementIcon,
  'info-filled': infoFilledIcon,
  'info': infoIcon,
  'iot-cloud': iotCloudIcon,
  'ip-pin': ipPinIcon,
  'key': keyIcon,
  'kpi-bar': kpiBarIcon,
  'lightning': lightningIcon,
  'link': linkIcon,
  'list-view': listViewIcon,
  'load-failure': loadFailureIcon,
  'locked': lockedIcon,
  'map-pin': mapPinIcon,
  'marketplace': marketplaceIcon,
  'media': mediaIcon,
  'message': messageIcon,
  'module': moduleIcon,
  'move': moveIcon,
  'network-operator': networkOperatorIcon,
  'network': networkIcon,
  'notifications-off': notificationsOffIcon,
  'notifications': notificationsIcon,
  'origin-services': originServicesIcon,
  'pendo-tour': pendoTourIcon,
  'phone': phoneIcon,
  'pin-outline': pinOutlineIcon,
  'pin': pinIcon,
  'pointer': pointerIcon,
  'print': printIcon,
  'progress': progressIcon,
  'redo': redoIcon,
  'reload': reloadIcon,
  'reset': resetIcon,
  'schedule-reports': scheduleReportsIcon,
  'schedule': scheduleIcon,
  'search': searchIcon,
  'security-alert-filled': securityAlertFilledIcon,
  'security-alert': securityAlertIcon,
  'security-shield': securityShieldIcon,
  'server': serverIcon,
  'settings': settingsIcon,
  'share': shareIcon,
  'show': showIcon,
  'snapshot': snapshotIcon,
  'sort-ascending': sortAscendingIcon,
  'sort-descending': sortDescendingIcon,
  'sort': sortIcon,
  'ssl-off': sslOffIcon,
  'ssl': sslIcon,
  'stack': stackIcon,
  'star-empty': starEmptyIcon,
  'star-filled': starFilledIcon,
  'status-alert-filled': statusAlertFilledIcon,
  'status-alert': statusAlertIcon,
  'status-denied-filled': statusDeniedFilledIcon,
  'status-failure-filled': statusFailureFilledIcon,
  'status-failure': statusFailureIcon,
  'status-success-filled': statusSuccessFilledIcon,
  'status-success': statusSuccessIcon,
  'subtract-circle': subtractCircleIcon,
  'subtract': subtractIcon,
  'support-headset': supportHeadsetIcon,
  'swap': swapIcon,
  'table-view': tableViewIcon,
  'tag-filled': tagFilledIcon,
  'tag': tagIcon,
  'task': taskIcon,
  'thumb-up': thumbUpIcon,
  'tip-lightbulb': tipLightbulbIcon,
  'tls-off': tlsOffIcon,
  'tls': tlsIcon,
  'undo': undoIcon,
  'unlocked': unlockedIcon,
  'upload': uploadIcon,
  'user-add': userAddIcon,
  'user-content': userContentIcon,
  'user-remove': userRemoveIcon,
  'user': userIcon,
  'users': usersIcon,
  'view-details': viewDetailsIcon,
  'waf': wafIcon,
  'wizard': wizardIcon,
  'wrench': wrenchIcon,
  'zoom-in': zoomInIcon,
  'zoom-out': zoomOutIcon,
};
